import { ReactComponent as UserIcon } from "../assets/icons/user-field.svg";
import { ReactComponent as MailIcon } from "../assets/icons/mail.svg";
import { ReactComponent as TitleIcon } from "../assets/icons/pencil-title.svg";
import { ReactComponent as PhoneIcon } from "../assets/icons/phone.svg";
import { ReactComponent as HomeIcon } from "../assets/icons/home.svg";
import { ReactComponent as CityIcon } from "../assets/icons/city.svg";
import { ReactComponent as PostcodeIcon } from "../assets/icons/postcode.svg";
import { ReactComponent as CountryIcon } from "../assets/icons/country-globe.svg";
import { ReactComponent as StateIcon } from "../assets/icons/pin-location.svg";
import { ReactComponent as ErrorIcon } from "../assets/icons/error-info.svg";
import { ReactComponent as ErrorTriangle } from "../assets/icons/error-triangle.svg";
import { ReactComponent as SuccessIcon } from "../assets/icons/success-tick.svg";
import { ReactComponent as SelectedIcon } from "../assets/icons/selected.svg";
import { ReactComponent as CheckIcon } from "../assets/icons/check.svg";
import { ReactComponent as SpinnerIcon } from "../assets/icons/spinner.svg";

import { ReactComponent as AddIcon } from "../assets/icons/Add.svg";
import { ReactComponent as BedIcon } from "../assets/icons/bed.svg";
import { ReactComponent as DiningIcon } from "../assets/icons/dining.svg";
import { ReactComponent as CocktailsIcon } from "../assets/icons/cocktails.svg";
import { ReactComponent as GiftIcon } from "../assets/icons/cocktails.svg";

import { ReactComponent as CaretLeftIcon } from "../assets/icons/caret-left.svg";
import { ReactComponent as CloseIcon } from "../assets/icons/close.svg";
import { ReactComponent as HelpIcon } from "../assets/icons/help.svg";
import { ReactComponent as UserHeaderIcon } from "../assets/icons/user.svg";

import { ReactComponent as ArrowNextIcon } from "../assets/icons/arrow-next.svg";
import { ReactComponent as CaretUpIcon } from "../assets/icons/caret-up.svg";
import { ReactComponent as PromoIcon } from "../assets/icons/promo.svg";
import { ReactComponent as ConfirmedIcon } from "../assets/icons/confirmed.svg";

import { ReactComponent as OneIcon } from "../assets/icons/num-one.svg";
import { ReactComponent as TwoIcon } from "../assets/icons/num-two.svg";

import { ReactComponent as CheckBoxIcon } from "../assets/icons/check-box.svg";
import { ReactComponent as CheckBoxBlankIcon } from "../assets/icons/check-blank.svg";

import { ReactComponent as ButtonEditIcon } from "../assets/icons/button-edit.svg";
import { ReactComponent as MapMarkerIcon } from "../assets/icons/map-marker.svg";
import { ReactComponent as HelpOutlineIcon } from "../assets/icons/help-outline.svg";

import { ReactComponent as LoadingIcon } from "../assets/icons/loading.svg";
import { ReactComponent as ChatIcon } from "../assets/icons/chat.svg";
import { ReactComponent as CaretRightIcon } from "../assets/icons/caret-right.svg";

import { ReactComponent as PoweredByStripeIcon } from "../assets/icons/powered-by-stripe.svg";

import { ReactComponent as NumberOneIcon } from "../assets/icons/icon-circle-one.svg";
import { ReactComponent as NumberTwoIcon } from "../assets/icons/icon-circle-two.svg";
import { ReactComponent as NumberThreeIcon } from "../assets/icons/icon-circle-three.svg";
import { ReactComponent as NumberFourIcon } from "../assets/icons/icon-circle-four.svg";
import { ReactComponent as NextArrowIcon } from "../assets/icons/next-arrow.svg";

import { ReactComponent as AdvantageCheck } from "../assets/icons/AdvantageCheckIcon.svg";
import { ReactComponent as ProductSelectedIcon } from "../assets/icons/ProductSelectedIcon.svg";

import { ReactComponent as AllLogo } from "../assets/icons/ALL-logo.svg";
import { ReactComponent as AllRewardsPointsIcon } from "../assets/icons/AllRewardsPoints.svg";
import { ReactComponent as InformationIcon } from "../assets/icons/information-icon.svg";

const State = () => {
  return <StateIcon />;
};
const Country = () => {
  return <CountryIcon />;
};
const Postcode = () => {
  return <PostcodeIcon />;
};
const City = () => {
  return <CityIcon />;
};
const Home = () => {
  return <HomeIcon />;
};
const Phone = () => {
  return <PhoneIcon />;
};
const Title = () => {
  return <TitleIcon />;
};
const Mail = () => {
  return <MailIcon />;
};
const User = () => {
  return <UserIcon />;
};
const SpinnerLoading = () => {
  return <SpinnerIcon />;
};

const Error = () => {
  return <ErrorIcon />;
};
const ErrorInput = () => {
  return <ErrorTriangle />;
};
const Success = () => {
  return <SuccessIcon />;
};
const Selected = () => {
  return <SelectedIcon />;
};
const Check = () => {
  return <CheckIcon />;
};

const Add = () => {
  return <AddIcon />;
};
const Bed = () => {
  return <BedIcon />;
};
const Dining = () => {
  return <DiningIcon />;
};
const Cocktails = () => {
  return <CocktailsIcon />;
};
const Gift = () => {
  return <GiftIcon />;
};

const Caret = () => {
  return <CaretLeftIcon />;
};
const Close = () => {
  return <CloseIcon />;
};
const Help = () => {
  return <HelpIcon />;
};
const UserHeader = () => {
  return <UserHeaderIcon />;
};

const ArrowNext = (e) => {
  return <ArrowNextIcon className={e.className} />;
};
const Promo = () => {
  return <PromoIcon />;
};
const CaretUp = (e) => {
  return <CaretUpIcon className={e.className} />;
};
const Confirmed = (e) => {
  return <ConfirmedIcon />;
};

const NumOne = () => {
  return <OneIcon />;
};
const TwoOne = () => {
  return <TwoIcon />;
};

const CheckBoxTick = () => {
  return <CheckBoxIcon />;
};
const CheckBoxBlank = () => {
  return <CheckBoxBlankIcon />;
};

const ButtonEdit = () => {
  return <ButtonEditIcon />;
};

const MapMarker = () => {
  return <MapMarkerIcon />;
};
const HelpOutline = () => {
  return <HelpOutlineIcon />;
};
const LoadingSvg = (e) => {
  return <LoadingIcon className={e.className} />;
};
const Chat = () => {
  return <ChatIcon />;
};
const CaretRight = () => {
  return <CaretRightIcon />;
};
const PoweredByStripe = () => {
  return <PoweredByStripeIcon />;
};

const NumberOne = () => {
  return <NumberOneIcon />;
};
const NumberTwo = () => {
  return <NumberTwoIcon />;
};
const NumberThree = () => {
  return <NumberThreeIcon />;
};
const NumberFour = () => {
  return <NumberFourIcon />;
};
const NextArrow = (e) => {
  return <NextArrowIcon className={e.className} />;
};

const AllLogoIcon = () => {
  return <AllLogo />;
};

const AdvantageCheckIcon = () => {
  return <AdvantageCheck />;
};
const ProductSelect = () => {
  return <ProductSelectedIcon />;
};
const AllRewardsPoints = () => {
  return <AllRewardsPointsIcon />;
};
const InformationCircleIcon = () => {
  return <InformationIcon />;
};

export {
  State,
  Country,
  Postcode,
  City,
  Home,
  Phone,
  Title,
  Mail,
  User,
  Error,
  Success,
  Bed,
  Dining,
  Cocktails,
  Gift,
  Caret,
  Close,
  Help,
  UserHeader,
  Selected,
  Check,
  SpinnerLoading,
  ArrowNext,
  Promo,
  CaretUp,
  Confirmed,
  NumOne,
  TwoOne,
  CheckBoxTick,
  CheckBoxBlank,
  ButtonEdit,
  MapMarker,
  HelpOutline,
  LoadingSvg,
  Chat,
  CaretRight,
  Add,
  PoweredByStripe,
  NumberOne,
  NumberTwo,
  NumberThree,
  NumberFour,
  AllLogoIcon,
  ErrorInput,
  AdvantageCheckIcon,
  ProductSelect,
  AllRewardsPoints,
  NextArrow,
  InformationCircleIcon
};
